import { useEffect, useState } from 'react';
import { fetchProtectedFile } from '../Services/AuthenticatedFiles';
import { useSessionStore } from '../Stores/Session';

/** Blob fallback also supports WebViews where service workers are unavailable. */
export default function ProtectedConversationAttachment({ attachment }: { attachment: { url: string; name?: string; type?: string } }) {
  const session = useSessionStore((state) => state.session);
  const [media, setMedia] = useState<{ url: string; type: string; identity?: string }>();
  const [error, setError] = useState(false);
  useEffect(() => {
    let disposed = false;
    let objectUrl: string | undefined;
    setMedia(undefined); setError(false);
    if (!session?.fileAccessToken) { setError(true); return; }
    fetchProtectedFile(attachment.url).then((r) => r.blob()).then((blob) => {
      if (disposed) return;
      objectUrl = URL.createObjectURL(blob);
      setMedia({ url: objectUrl, type: blob.type, identity: session.gleapId });
    }).catch(() => !disposed && setError(true));
    return () => { disposed = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [attachment.url, session?.fileAccessToken, session?.gleapId]);
  const current = media?.identity === session?.gleapId && !!session?.fileAccessToken ? media : undefined;
  if (error) return <span role="status">Sign in to view {attachment.name || 'attachment'}.</span>;
  if (!current) return <span>Loading attachment…</span>;
  return <div className="protected-conversation-attachment" onClick={(event) => event.stopPropagation()}>
    {current.type.startsWith('image/') && !current.type.includes('svg') && <img src={current.url} alt={attachment.name || 'Attachment'} style={{ maxWidth: '100%', maxHeight: 400 }} />}
    {current.type.startsWith('audio/') && <audio src={current.url} controls />}
    {current.type.startsWith('video/') && <video className="message-video-player" src={current.url} controls playsInline preload="metadata" aria-label={attachment.name || 'Video'} />}
    <a href={current.url} download={attachment.name || 'attachment'} onClick={(event) => event.stopPropagation()}>Download {attachment.name || 'attachment'}</a>
  </div>;
}
